import { render, staticRenderFns } from "./FoodForm.vue?vue&type=template&id=389763d1&scoped=true"
import script from "./FoodForm.vue?vue&type=script&lang=js"
export * from "./FoodForm.vue?vue&type=script&lang=js"
import style0 from "./FoodForm.vue?vue&type=style&index=0&id=389763d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389763d1",
  null
  
)

export default component.exports